import React, { useMemo } from "react";
import * as echarts from "echarts";
import { default as EchartsWrapper } from "src/components/Echarts";
import { peerAnalyticsPublishType } from "src/types/analytics";
import { getPublisherBitrateChartConfiguration } from "../../helpers/getPublishConfigurations";
type echartsOptions = echarts.EChartsOption;

export const PublisherBitrateChart = ({
  publishData,
  loading,
}: {
  publishData: peerAnalyticsPublishType;
  loading: boolean;
}) => {
  const peerPublisherBitrateChartoptions: echartsOptions = useMemo(
    () => getPublisherBitrateChartConfiguration(publishData),
    [publishData]
  );

  return (
    <>
      {/* @ts-ignore */}
      <EchartsWrapper
        options={{ ...peerPublisherBitrateChartoptions }}
        loading={loading}
        style={{ height: "240px", width: "auto" }}
      />
    </>
  );
};
